module.exports = __webpack_public_path__ + "img/NS-M-16.a4379973.svg";